export default __webpack_public_path__ + "static/media/send.e6589bc0.mp3";